import {
  AdvertisingArea, AdvertisingAreaDefinitionBranch,
  AdvertisingAreaDefinitions, AdvertisingAreaType,
  ApiResponse,
  BaseHttpService,
  CalculationParameter,
  PriceManagement
} from '@ems/api';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import {map, Observable, of, switchMap} from 'rxjs';
import { HttpCacheManager } from '@ngneat/cashew';

const expandParams = {
  'expand[0]': 'advertisingAreaType',
  'expand[1]': 'advertisingAreaDefinitions.advertisingAreaDefinitionBranches.branch.visitingAddress',
  'expand[2]': 'advertisingAreaDefinitions.medium.releaseSchedule',
  'expand[3]': 'advertisingAreaDefinitions.medium.publicationDay',
  'expand[4]': 'advertisingValidities',
  'expand[5]': 'updatedBy',
  'expand[6]': 'updatedBy'
}

@Injectable({
  providedIn: 'root'
})
export class AdvertisingAreasService extends BaseHttpService {
  override cacheEnabled = false;

  constructor(
    http: HttpClient,
    cookieService: CookieService,
    manager: HttpCacheManager,
  ) {
    super(http, cookieService, manager);
  }

  listAdvertisingAreas(params: any): Observable<ApiResponse<AdvertisingArea[]>> {
    this.invalidateCache();
    // Hinweis: Caller müssen benötigte expand[]-Parameter explizit übergeben.
    const queryParams: Record<string, any> = {
      ...params
    };
    return this.get('advertising-areas', queryParams);
  }

  listAdvertisingAreaType(params: any): Observable<any> {
    const queryParams: Record<string, any> = {
      ...params
    };
    return this.getAll('advertising-area-type', queryParams);
  }

  getAdvertisingArea(id: number, params?: any): Observable<any> {
    this.invalidateCache();
    // Hinweis: Caller müssen benötigte expand[]-Parameter explizit übergeben.
    const queryParams: Record<string, any> = {
      ...params
    };
    return this.get(`advertising-areas/${id}`, queryParams);
  }

  getAdvertisingAreaDefinitions(params: any): Observable<ApiResponse<AdvertisingAreaDefinitions[]>> {
    this.invalidateCache();
    const queryParams: Record<string, any> = {
      ...params
    };
    return this.get(`advertising-area-definitions`, queryParams);
  }

  updateAdvertisingAreaDefinitions(id: number, data: any) : Observable<ApiResponse<AdvertisingAreaDefinitions[]>> {
    this.invalidateCache();
    return this.post(`advertising-area-definitions/${id}`, data);
  }

  create(data: any): Observable<ApiResponse<AdvertisingArea>> {
    const url = this.addQueryParams('advertising-areas', expandParams);
    return this.post(url, data);
  }

  update(id: number, data: any): Observable<AdvertisingArea> {
    this.invalidateCache();
    return this.post(`advertising-areas/${id}`, data);
  }

  remove(id: number) {
    this.invalidateCache();
    return this.delete(`advertising-areas/${id}`);
  }

  createAdvertisingAreaDefinitionBranch(data: any): Observable<ApiResponse<AdvertisingAreaDefinitionBranch[]>> {
    this.invalidateCache();
    return this.post(`advertising-area-definition-branch`, data);
  }

  updateAdvertisingAreaDefinitionBranch(id: number, data: any): Observable<ApiResponse<AdvertisingAreaDefinitionBranch[]>> {
    this.invalidateCache();
    return this.post(`advertising-area-definition-branch/${id}`, data);
  }

  deleteAdvertisingAreaDefinitionBranch(id: number) {
    this.invalidateCache();
    return this.delete(`advertising-area-definition-branch/${id}`);
  }

  updateValidity(id: number, data: { advertising_area_id: number; year: number; week: number }): Observable<any> {
    this.invalidateCache();
    return this.post(`advertising-validities/${id}`, data);
  }
}
